import React, { useRef, useState } from 'react';
import { AiFillEye } from 'react-icons/ai';
import ReactInputMask, { Props as InputProps } from 'react-input-mask';

import { useField } from 'formik';

import colors from '~/styles/colors';

import { Container, Content, Optional, Label, Box } from './styles';

type Props = Omit<InputProps, 'mask'> & {
  name: string;
  label?: string;
  optional?: boolean;
  mask?: string;
};

const InputPassword: React.FC<Props> = ({
  name,
  label = null,
  optional = false,
  mask = '',
  defaultValue,
  ...rest
}) => {
  const [show, setShow] = useState<boolean>(false);

  const inputRef = useRef(null);
  const [field, meta, helpers] = useField(name);
  const { value } = field;
  const { error } = meta;
  const { setValue } = helpers;

  return (
    <Container>
      {(label || optional) && (
        <Box>
          {label && <Label htmlFor={name}>{label}</Label>}{' '}
          {optional && <Optional>(opcional)</Optional>}
        </Box>
      )}
      <Content>
        <ReactInputMask
          id={name}
          ref={inputRef}
          defaultValue={defaultValue}
          {...rest}
          mask={mask}
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            if (rest.onChange) {
              rest.onChange(e);
            }
          }}
          type={show ? 'text' : 'password'}
        />
        <AiFillEye
          size={23}
          color={show ? colors.primary : '#e6e6e6'}
          onClick={() => setShow(!show)}
        />
      </Content>
      {error && <span>{error}</span>}
    </Container>
  );
};

export default InputPassword;
